import router, { DynamicRoutes, resetRouter } from '@/router/index'
import { getRealRouter, getRealRouterLocal } from '@/utils/utilsRouter'
import dynamicRouter from '@/router/dynamic-router'
import { cloneObj } from "@/utils/utils.js";

export default {
	namespaced: true,
	state: {
		sidebarMenu: null /** 导航菜单 */,
		currentMenu: '' /** 当前active导航菜单 */,
	},
	getters: {},
	mutations: {
		SET_MENU(state, menu) {
			state.sidebarMenu = menu
		},
		CLEAR_MENU(state) {
			state.sidebarMenu = null
		},
		SET_CURRENT_MENU(state, currentMenu) {
			state.currentMenu = currentMenu
		},
	},
	actions: {
		async FETCH_PERMISSION({ commit, state }) {
			// resetRouter();
			// 本地配置好路由，后端返回具体显示哪个路由---开发环境测试使用
			// let permissionList1 = {
			// 	"data": [
			// 		"customers",
			// 		"customer",
			// 		"basicSets",
			// 		"company",
			// 		"operator",
			// 		'salesman',
			// 		'rolePermission',
			// 		'VIParameterConfig',
			// 		'products',
			// 		'info',
			// 		'classify',
			// 		'brand',
			// 		'unit',
			// 		'warehouse',
			// 		'group',
			// 		'storehouse',
			// 		'location',
			// 		'outAndIn',
			// 		'stockIn',
			// 		'stockOut',
			// 		'disassembly',
			// 		'assemble',
			// 		'inventory',
			// 		'systemParam',
			// 		'stockType',
			// 		'systemMenu',
			// 		'systemLog',
			// 		'erp',
			// 		'waitForStockIn',
			// 		'waitForStockOut',
			// 		'waitForDisassembly',
			// 		'waitForAssemble',
			// 	]
			// }
			// let routes = getRealRouterLocal(permissionList1.data, dynamicRouter);
			let routes = await getRealRouter();
			let MainContainer = cloneObj(DynamicRoutes);
			MainContainer.push(...routes);
			router.addRoutes(MainContainer);
			commit('CLEAR_MENU');
			// 左侧菜单显示
			let _child = JSON.parse(JSON.stringify(MainContainer));
			_child = _child.splice(1);
			commit('SET_MENU', _child );
		}
	}
}
